/* eslint-disable */
'use strict';
import { zxy } from './http-cache-store';
import axios from 'axios';

/* request pool */
let pending = [];

let HttpCacheMiddleware = function(cfg = {}) {

  let cacheConfig = {
    isCache: false,
    isStorage: 'zxyStore',
    isExpired: 10,
    ...cfg
  };

  let httpX = new newHttp(cacheConfig);
  
  httpX.axiosInterceptor();
  
  httpX.httpRequest();
  
  window['zxy-vue-storage'] = httpX.zxyCacheStorage;

};

function newHttp(cacheConfig = {}) {

  let { isExpired } = cacheConfig;

  this.http = axios;

  this.cacheConfig = cacheConfig;

  this.zxyCacheStorage = {

    zxyStore: new zxy({ storage: 'zxyStore', exp: isExpired }),

    localStorage: new zxy({ storage: 'localStorage', exp: isExpired }),

    sessionStorage: new zxy({

      storage: 'sessionStorage',

      exp: isExpired

    })

  };

}

newHttp.prototype = {

  wrapRequest: function(opts = {}) {

    let { isStorage } = this.cacheConfig;

    let cacheKey = this.cacheKey(opts);

    /* single interface cfg */
    if (opts.isStorage) isStorage = opts.isStorage;

    /* get cache */
    let cacheData = this.zxyCacheStorage[isStorage].get(cacheKey);

    /* return cache */
    if (cacheData) return Promise.resolve(cacheData);

    return this.http.request(opts);

  },

  httpRequest: function() {

    let { isCache } = this.cacheConfig;

    if (isCache) {

      ['get', 'delete', 'head', 'jsonp'].forEach(method => {

        /* rewrite http */
        this.http[method] = (url, config) => {
          
          return this.wrapRequest({ url, ...config, method });
          
        }

      });

    }

  },

  axiosInterceptor: function() {

    /* default cacheConfig */
    let { isCache, isStorage, isExpired } = this.cacheConfig;

    let cancelToken = this.http.CancelToken;

    let removePending = cfg => {

      for (let p in pending) {

        if (pending[p].key === this.cacheKey(cfg)) {

          pending[p].fn();

          pending.splice(p, 1);

        }

      }

    };

    if (isCache) {

      /* request interceptors */
      this.http.interceptors.request.use(cfg => {

        removePending(cfg);

        /* add cancelToken */
        cfg.cancelToken = new cancelToken(c => {

          let cacheKey = this.cacheKey(cfg);
 
          pending.push({ key: cacheKey, fn: c });
        
        });

        if (cfg.data) {
          /* single interface cfg */
          isStorage = cfg.data.isStorage || isStorage;

          isExpired = cfg.data.isExpired || isExpired;

          isCache = cfg.data.isCache || isCache;

          delete cfg.data.isStorage;
          delete cfg.data.isExpired;
          delete cfg.data.isCache;
        }

        return cfg;
      });

      /* response interceptors */
      this.http.interceptors.response.use(res => {

        removePending(res.config);

        let storage = this.zxyCacheStorage[isStorage];

        let cacheKey = this.cacheKey(res.config);

        storage.deleteAllExpires();

        isCache &&
        !storage.get(cacheKey) &&
        storage.set(cacheKey, res, { exp: isExpired });

        return res;

      }, err => {

        return Promise.reject(err);

      });

    }

  },

  cacheKey: function(opts = {}) {

    let { method, url, data } = opts;

    data = (data && JSON.stringify(data)) || '{}';

    url = url.indexOf('/') !== 0 ? `/${url}` : url;

    /* cache key */
    return method.toUpperCase() + url + data;

  }

};

export {HttpCacheMiddleware}